//所有有关用户信息的网络请求
import http from '../utils/http'

//autoLoginFreeGift 列表
export function autoLoginFreeGiftList(params){
    return http({
      url:`/review/user/level`,
      method:'get',
      params:params,
    })
}
//新建(不用调)
export function addAutoLoginFreeGift(data){
  return http({
    url:`/review/user/level`,
    method:'post',
    data,
  })
}
//修改
export function editAutoLoginFreeGift({id,data}){
  return http({
    url:`/review/user/level/${id}`,
    method:'put',
    data,
  })
}